import { createAsyncThunk } from '@reduxjs/toolkit';
import { URLS } from 'constants/api.constants';
import { axiosInstance } from 'utils/axios';

export const getCourses = createAsyncThunk(
  'get/courses',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(URLS.COURSES.GET_COURSES);
      if (response?.data?.success) {
        return response.data;
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const getSingleCourses = createAsyncThunk(
  'course/getSingleCourse',
  async ({ courseId }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        `${URLS.COURSES.GET_SINGLE_COURSES}/${courseId}`
      );
      if (response?.data?.success) {
        return response.data;
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const getCoursesAccordion = createAsyncThunk(
  'get/accordion',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(
        URLS.COURSES.GET_ACCORDION_COURSES
      );
      if (response?.data?.success) {
        return response?.data;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
